<div class="oiq-ui-dialog" (keydown.esc)="close()" tabindex="0">
  <header>
    <div class="__title">
      <div>
        @if (!addingClient()) {
          <h2 class="mb-2">Search for client</h2>
          <p class="title-description">Type the business name into the search</p>
        } @else {
          <h2 class="mb-2">Add New Client</h2>
          <p class="title-description">
            This client will be created for:
            <span class="font-medium text-primary">{{ whiteLabel?.name }}</span>
          </p>
        }
      </div>
      <button (click)="close()" class="oiq-button oiq-button--link __close" type="button">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>
  </header>
  <main class="space-y-2">
    @if (!addingClient()) {
      <oiq-client-search-history
        [whiteLabelId]="searchWhitelabelId"
        [canCreate]="true"
        [showHistory]="true"
        [enableSelectClient]="data.enableSelectClient"
        [enableSelectApplication]="data.enableSelectApplication"
        [enableSelectFunding]="data.enableSelectFunding"
        [enableButtonOptions]="data.enableButtonOptions"
        [enableMenuOptions]="data.enableMenuOptions"
        (event)="handleHistoryEvent($event)"></oiq-client-search-history>
    } @else {
      <!-- Add New Client Form -->
      <oiq-client-create-form
        [configuration]="{
          whiteLabelId: data?.whiteLabelId,
          whiteLabels: data?.whiteLabels
        }"
        [showBackButton]="true"
        (event)="handleFormEvent($event)"></oiq-client-create-form>
    }
  </main>
  <footer>
    <div class="__left"><!-- LEFT --></div>
    <div class="__right">
      @let _createRef = createFormRef();
      @if (!addingClient()) {
      } @else if (_createRef) {
        <button
          class="oiq-button oiq-button--outline"
          (click)="close()"
          [disabled]="_createRef.formRef.busy$ | async">
          Cancel
        </button>
        <button
          class="oiq-button oiq-button--primary--solid"
          [disabled]="_createRef.formRef.busy$ | async"
          (click)="submitNewClient()">
          Save as new Client
        </button>
      }
    </div>
  </footer>
</div>
